import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import {ItemId, UserPermissions} from '../../../types/items';

export const initUserPermissionsRequest = action(
  'INIT_USER_PERMISSIONS_REQUEST',
  withPayload,
);
export const initUserPermissionsSuccess = action(
  'INIT_USER_PERMISSIONS_SUCCESS',
  withPayload<UserPermissions>(),
);
export const initUserPermissionsFail = action(
  'INIT_USER_PERMISSIONS_FAIL',
  withoutPayload,
);

export const getUserPermissionsRequest = action(
  'GET_USER_PERMISSIONS_REQUEST',
  withPayload<ItemId>(),
);
export const getUserPermissionsSuccess = action(
  'GET_USER_PERMISSIONS_SUCCESS',
  withPayload<UserPermissions>(),
);
export const getUserPermissionsFail = action(
  'GET_USER_PERMISSIONS_FAIL',
  withoutPayload,
);

export const getUserPermissionsListRequest = action(
  'GET_USER_PERMISSIONS_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getUserPermissionsListSuccess = action(
  'GET_USER_PERMISSIONS_LIST_SUCCESS',
  withPayload<ItemList<UserPermissions>>(),
);
export const getUserPermissionsListFail = action(
  'GET_USER_PERMISSIONS_LIST_FAIL',
  withoutPayload,
);

export const setUserPermissionsListDirty = action(
  'SET_USER_PERMISSIONS_LIST_DIRTY',
  withPayload<boolean>(),
);

export const deleteUserPermissionsRequest = action(
  'DELETE_USER_PERMISSIONS_REQUEST',
  withPayload<ItemId>(),
);
export const deleteUserPermissionsSuccess = action(
  'DELETE_USER_PERMISSIONS_SUCCESS',
  withoutPayload,
);
export const deleteUserPermissionsFail = action(
  'DELETE_USER_PERMISSIONS_FAIL',
  withoutPayload,
);

export const createUserPermissionsRequest = action(
  'CREATE_USER_PERMISSIONS_REQUEST',
  withPayload<UserPermissions>(),
);
export const createUserPermissionsSuccess = action(
  'CREATE_USER_PERMISSIONS_SUCCESS',
  withPayload<UserPermissions>(),
);
export const createUserPermissionsFail = action(
  'CREATE_USER_PERMISSIONS_FAIL',
  withoutPayload,
);

export const saveUserPermissionsRequest = action(
  'SAVE_USER_PERMISSIONS_REQUEST',
  withPayload<UserPermissions>(),
);
export const saveUserPermissionsSuccess = action(
  'SAVE_USER_PERMISSIONS_SUCCESS',
  withPayload<UserPermissions>(),
);
export const saveUserPermissionsFail = action(
  'SAVE_USER_PERMISSIONS_FAIL',
  withoutPayload,
);

export const saveUserPermissionsRequestDirty = action(
  'SAVE_USER_PERMISSIONS_REQUEST_DIRTY',
  withPayload<UserPermissions>(),
);
export const saveUserPermissionsSuccessDirty = action(
  'SAVE_USER_PERMISSIONS_SUCCESS_DIRTY',
  withPayload<UserPermissions>(),
);
export const saveUserPermissionsFailDirty = action(
  'SAVE_USER_PERMISSIONS_FAIL_DIRTY',
  withoutPayload,
);

export const inviteUserPermissionsRequest = action(
  'INVITE_USER_PERMISSIONS_REQUEST',
  withPayload<UserPermissions>(),
);
export const inviteUserPermissionsSuccess = action(
  'INVITE_USER_PERMISSIONS_SUCCESS',
  withoutPayload,
);

export const resendInviteUserPermissionsRequest = action(
  'RESEND_INVITE_USER_PERMISSIONS_REQUEST',
  withPayload<UserPermissions>(),
);
export const resendInviteUserPermissionsSuccess = action(
  'RESEND_INVITE_USER_PERMISSIONS_SUCCESS',
  withoutPayload,
);

export const resetCurrentUserPermissions = action(
  'RESET_CURRENT_USER_PERMISSIONS',
  withoutPayload,
);

export const setUserPermissionsListRedirect = action(
  'SET_USER_PERMISSIONS_LIST_REDIRECT',
  withPayload<boolean>(),
);

export const setOptionSendEmail = action(
  'SET_OPTION_SEND_EMAIL',
  withPayload<boolean>(),
);
export const setOptionSender = action(
  'SET_OPTION_SENDER',
  withPayload<boolean>(),
);
export const setOptionRequestRegistration = action(
  'SET_OPTION_REQUEST_REGISTRATION',
  withPayload<boolean>(),
);
export const setOptionRequestBilling = action(
  'SET_OPTION_REQUEST_BILLING',
  withPayload<boolean>(),
);

export const getUserPermissionsListByUserRequest = action(
  'GET_USER_PERMISSIONS_LIST_BY_USER_REQUEST',
  withPayload<ItemId>(),
);
export const getUserPermissionsListByUserSuccess = action(
  'GET_USER_PERMISSIONS_LIST_BY_USER_SUCCESS',
  withPayload<ItemList<UserPermissions>>(),
);
export const getUserPermissionsListByUserFail = action(
  'GET_USER_PERMISSIONS_LIST_BY_USER_FAIL',
  withoutPayload,
);
export const clearUserPermissionsListByUser = action(
  'CLEAR_USER_PERMISSIONS_LIST_BY_USER',
  withoutPayload,
);
export const clearUserPermissionsList = action(
  'CLEAR_USER_PERMISSIONS_LIST',
  withoutPayload,
);
export const clearSelectedUserPermissionsList = action(
  'CLEAR_SELECTED_USER_PERMISSIONS_LIST',
  withoutPayload,
);
